import { t } from '@lingui/core/macro';
import { FieldNumericController, InputAdornment } from '@luminovo/design-system';
import type { JSX } from 'react';
import { Control, FieldValues, Path } from 'react-hook-form';

export function FieldScrapMax<T extends FieldValues>({
    readOnly,
    control,
    name,
    min,
}: {
    readOnly: boolean;
    control: Control<T>;
    name: Path<T>;
    min: number | undefined;
}): JSX.Element {
    return (
        <FieldNumericController
            control={control}
            name={name}
            min={min}
            FieldProps={{
                label: t`Maximum`,
                slotProps: {
                    input: {
                        endAdornment: <InputAdornment position="end">{t`Pieces`}</InputAdornment>,
                        readOnly,
                    },
                },
            }}
        />
    );
}
